<template>
  <v-card id="question">
    <v-container>
      <v-row align="center">
        <v-spacer />
        <!-- 確認テストQ.X -->
        <v-col cols="2" class="">
          <div class="text-center">
            Q. {{ questionNum }}
          </div>
        </v-col>
        <!-- 問題文 -->
        <v-col cols="10" class="my-3">
          <template v-if="questionImageFlag == '1'">
            {{ questionText }}
            <v-spacer />
            <img class="qimg" :src="require(`@/assets/courseUnittestImg/${courseId}/${unitNum}/${questionImage}`)" />
          </template>
          <template v-else-if="questionImageFlag == '2'">
            <display-tex>
              {{ questionText }}
            </display-tex>
          </template>
          <template v-else-if="questionImageFlag == '3'">
            <display-tex>
              {{ questionText }}
            </display-tex>
            <v-spacer />
            <img class="qimg" :src="require(`@/assets/courseUnittestImg/${courseId}/${unitNum}/${questionImage}`)" />
          </template>
          <template v-else-if="questionImageFlag == '4'">
            <img class="qimg" :src="require(`@/assets/courseUnittestImg/${courseId}/${unitNum}/${questionImage}`)" />
          </template>
          <template v-else-if="questionImageFlag == '5'">
            <display-tex>
              {{ questionText }}
            </display-tex>
            <v-spacer />
            <img class="qimg_small" :src="require(`@/assets/courseUnittestImg/${courseId}/${unitNum}/${questionImage}`)" />
          </template>
          <template v-else>
            {{ questionText }}
          </template>
        </v-col>
        <v-col v-if="testResult" cols="10">
          <v-container v-if="testResult.userAnswers[questionNum - 1].correct === 1" class="ml-5">
            <v-row align="center">
              <v-col cols="2" />
              <v-col cols="1">
                <v-icon large color="green darken-2">
                  mdi-checkbox-marked-circle
                </v-icon>
              </v-col>
              <v-col> 正解 </v-col>
            </v-row>
          </v-container>
          <v-container v-if="testResult.userAnswers[questionNum - 1].correct === 0" class="ml-5">
            <template v-if="examQualified !== true">
              <v-row align="center">
                <v-col cols="2" />
                <v-col cols="1">
                  <v-icon large color="red darken-2">
                    mdi-close-circle
                  </v-icon>
                </v-col>
                <v-col> 不正解 </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-row align="center">
                <v-col cols="2" />
                <v-col cols="1">
                  <v-icon large color="red darken-2">
                    mdi-close-circle
                  </v-icon>
                </v-col>
                <v-col>不正解（正解を以下に表示しています）</v-col>
              </v-row>
            </template>
          </v-container>
        </v-col>
      </v-row>
      <!-- 選択肢 -->
      <!-- v-colを追加 -->
      <v-row cols="12" justify="end">
        <v-col cols="10" class="pa-0 ma-0">
          <v-list shaped :disabled="isTestFinished" class="">
            <div
              v-for="(choice, index) in choices"
              :key="`choice-${index}`"
            >
              <template v-if="choice.choice !== ''">
                <v-list-item-group
                  v-if="isMultipleAnswers"
                  v-model="selectedAnswer"
                  :multiple="isMultipleAnswers"
                >
                  <template v-if="choice.choice !== ''">
                    <v-list-item :value="choice.questionNumber">
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox
                            :input-value="active"
                            color="light-grey accent-4"
                          />
                        </v-list-item-action>
                        <v-list-item-content>
                          <template v-if="choicesImageFlag == '1'">
                            <img class="qcimg" :src="require(`@/assets/courseUnittestImg/${courseId}/${unitNum}/${choice.choice}`)" />
                          </template>
                          <template v-else-if="choicesImageFlag == '2'">
                            <display-tex>
                              {{ choice.choice }}
                            </display-tex>
                          </template>
                          <template v-else-if="choicesImageFlag == '3'">
                            <display-tex>
                              {{ choice.choice }}
                            </display-tex>
                          </template>
                          <template v-else>
                            {{ choice.choice }}
                          </template>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </template>
                </v-list-item-group>
                <v-radio-group
                  v-else
                  v-model="selectedAnswer"
                  class="ml-4"
                  :multiple="isMultipleAnswers"
                >
                  <v-radio :value="choice.questionNumber">
                    <template v-slot:label>
                      <template v-if="choicesImageFlag == '1'">
                        <img class="qcimg" :src="require(`@/assets/courseUnittestImg/${courseId}/${unitNum}/${choice.choice}`)" />
                      </template>
                      <template v-else-if="choicesImageFlag == '2'">
                        <display-tex>
                          {{ choice.choice }}
                        </display-tex>
                      </template>
                      <template v-else-if="choicesImageFlag == '3'">
                        <template v-if="choice.choice.indexOf('.jpg')!='-1'">
                          <img class="qcimg" :src="require(`@/assets/courseUnittestImg/${courseId}/${unitNum}/${choice.choice}`)" />
                        </template>
                        <template v-else>
                          <display-tex>
                            {{ choice.choice }}
                          </display-tex>
                        </template>
                      </template>
                      <template v-else-if="choicesImageFlag == '4'">
                        <img class="qcimg_middle" :src="require(`@/assets/courseUnittestImg/${courseId}/${unitNum}/${choice.choice}`)" />
                      </template>
                      <template v-else-if="choicesImageFlag == '5'">
                        <img class="qcimg_large" :src="require(`@/assets/courseUnittestImg/${courseId}/${unitNum}/${choice.choice}`)" />
                      </template>
                      <template v-else>
                        {{ choice.choice }}
                      </template>
                    </template>
                  </v-radio>
                </v-radio-group>
              </template>
            </div>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import repository from '@/store/repository'
import DisplayTex from '@/components/pages/unitTest/DisplayTex.vue'

export default {
  name: 'Question',
  components: {
    DisplayTex
  },
  props: {
    questionData: {
      type: Object,
      require: true,
      default: () => {}
    },
    isTestFinished: {
      type: Boolean,
      require: true,
      default: false
    },
    testResult: {
      type: Object,
      default: () => {}
    },
    examQualified: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      courseId: this.questionData.courseId,
      unitNum: this.questionData.unitNum,
      unitTitle: this.questionData.unitTitle,
      questionNum: this.questionData.questionNum,
      numOfQuestions: this.questionData.numOfQuestions,
      multipleAns: this.questionData.multipleAns,
      questionImageFlag: this.questionData.questionImageFlag,
      questionText: this.questionData.questionText,
      questionImage: this.questionData.questionImage,
      choicesImageFlag: this.questionData.choicesImageFlag,
      correctAnswers: [this.questionData.correctAns1, this.questionData.correctAns2, this.questionData.correctAns3],
      explanationText: this.questionData.explanationText,
      selected: null
    }
  },
  computed: {
    isMultipleAnswers: function () {
      if (this.multipleAns === 0) {
        return false
      } else {
        return true
      }
    },
    selectedAnswer: {
      get () {
        if (this.examQualified && this.testResult !== null) {
          if (this.isMultipleAnswers) {
            if (this.testResult.userAnswers[this.questionNum - 1].correct) {
              return this.testResult.userAnswers[this.questionNum - 1].choices.filter(Boolean)
            } else {
              return this.correctAnswers.filter(Boolean)
            }
          } else {
            if (this.testResult.userAnswers[this.questionNum - 1].correct) {
              return this.testResult.userAnswers[this.questionNum - 1].choices[0]
            } else {
              return this.correctAnswers[0]
            }
          }
        } else {
          return this.selected
        }
      },
      set (newValue) {
        this.$emit('answerQuestion', {
          questionNum: this.questionNum,
          choices: newValue
        })
        this.selected = newValue
      }
    },
    choices: function () {
      const choices = [
        {
          questionNumber: 1,
          choice: this.questionData.choice1
        },
        {
          questionNumber: 2,
          choice: this.questionData.choice2
        },
        {
          questionNumber: 3,
          choice: this.questionData.choice3
        },
        {
          questionNumber: 4,
          choice: this.questionData.choice4
        },
        {
          questionNumber: 5,
          choice: this.questionData.choice5
        },
        {
          questionNumber: 6,
          choice: this.questionData.choice6
        },
        {
          questionNumber: 7,
          choice: this.questionData.choice7
        },
        {
          questionNumber: 8,
          choice: this.questionData.choice8
        }
      ]

      if (repository.isQuestionRandom()) {
        this.fisherYatesShuffle(choices)
      }

      return choices
    }
  },
  watch: {
    selectedAnswer: function () {
      this.$emit('answerQuestion', {
        questionNum: this.questionNum,
        choices: this.selectedAnswer
      })
    }
  },

  mounted: function () {},

  methods: {
    fisherYatesShuffle (arr) {
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1)); // random index
        [arr[i], arr[j]] = [arr[j], arr[i]] // swap
      }
    }
  }
}
</script>

<style scoped>
#question {
  text-align: initial;
  white-space: pre-wrap;
}
</style>
<style lang="scss">
    span {
        .mord.accent {
            background-color: inherit !important;
            border-color: inherit !important;
        }
    }
</style>
